// The On Demand Staff stream endpoints are gated on the `management-company-id` header
// (authorizeOperationForManagementCompany), which a plain navigation/window.open cannot send — so both View and
// Download fetch the file (with the header + session cookie) and use an object URL. View opens it in a new tab;
// Download forces a save.
const parseFilename = (contentDisposition) => {
	const match = contentDisposition && contentDisposition.match(/filename="?([^"]+)"?/);
	return match ? match[1] : 'attachment';
};

const fetchAttachment = async (attachmentUrl, managementCompanyId) => {
	const response = await fetch(attachmentUrl, {
		credentials: 'include',
		headers: { 'management-company-id': managementCompanyId }
	});
	if (!response.ok) {
		throw new Error('Failed to fetch attachment');
	}
	const blob = await response.blob();
	return {
		objectUrl: window.URL.createObjectURL(blob),
		filename: parseFilename(response.headers.get('content-disposition'))
	};
};

// Must be called straight from the click handler: the tab is opened before the first await so the pop-up is tied to
// the click gesture. Closes the tab and rethrows when the fetch fails.
export const viewAttachment = async (attachmentUrl, managementCompanyId) => {
	const newTab = window.open('', '_blank');
	try {
		const { objectUrl } = await fetchAttachment(attachmentUrl, managementCompanyId);
		if (newTab) {
			newTab.location = objectUrl;
		}
	} catch (error) {
		if (newTab) {
			newTab.close();
		}
		throw error;
	}
};

export const downloadAttachment = async (attachmentUrl, managementCompanyId) => {
	const { objectUrl, filename } = await fetchAttachment(attachmentUrl, managementCompanyId);
	const link = document.createElement('a');
	link.href = objectUrl;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	link.remove();
	window.URL.revokeObjectURL(objectUrl);
};
